'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditResult(items, total, page, size, until, names) {
  this.Ca = null;
  this.rK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Jo = 0;
  this.Jp = 0;
  this.Cc = null;
  this.Cb = null;
  this.Ca = items;
  this.rK = total;
  this.Jo = page;
  this.Jp = size;
  this.Cc = until;
  this.Cb = names;
}
export { $c_Lpresto_AuditView$AuditResult as $c_Lpresto_AuditView$AuditResult };
$p = $c_Lpresto_AuditView$AuditResult.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditResult;
/** @constructor */
function $h_Lpresto_AuditView$AuditResult() {
}
export { $h_Lpresto_AuditView$AuditResult as $h_Lpresto_AuditView$AuditResult };
$h_Lpresto_AuditView$AuditResult.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("AuditResult"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ca));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.rK;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Jo);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Jp);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cc));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cb));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AuditView$AuditResult)) {
    var this$1 = this.rK;
    var b = x$0.rK;
    if (((((this$1.e === b.e) && (this$1.f === b.f)) && (this.Jo === x$0.Jo)) && (this.Jp === x$0.Jp))) {
      var x = this.Ca;
      var x$2 = x$0.Ca;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Cc;
      var x$4 = x$0.Cc;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Cb;
      var x$6 = x$0.Cb;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "AuditResult";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Ca;
      break;
    }
    case 1: {
      return this.rK;
      break;
    }
    case 2: {
      return this.Jo;
      break;
    }
    case 3: {
      return this.Jp;
      break;
    }
    case 4: {
      return this.Cc;
      break;
    }
    case 5: {
      return this.Cb;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AuditView$AuditResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hP)));
}
export { $isArrayOf_Lpresto_AuditView$AuditResult as $isArrayOf_Lpresto_AuditView$AuditResult };
var $d_Lpresto_AuditView$AuditResult = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditResult, "presto.AuditView$AuditResult", ({
  hP: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AuditView$AuditResult as $d_Lpresto_AuditView$AuditResult };
//# sourceMappingURL=presto.-Audit-View$-Audit-Result.js.map
